import { push, RouterAction } from 'connected-react-router';
import { ThunkAction } from 'redux-thunk';

/**
 * ルーティング用モジュール？
 */
export interface PagesState { }

export type PagesAction = ThunkAction<void, PagesState, undefined, RouterAction>;

export function goUploadPage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/'));
  };
}

export function goLoginPage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/login'));
  };
}

export function goUploadHighlightPage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/uphilight'));
  };
}

export function goUploadSearchPage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/upsearch'));
  };
}

export function goComparisonPage(ids?: number[]): PagesAction {
  return (dispatch) => {
    if (ids) {
      dispatch(push(`/comparison/${JSON.stringify(ids)}`));
    } else {
      dispatch(push('/comparison'));
    }
  };
}

export function goComparisonHighlightPage(ids?: number[]): PagesAction {
  return (dispatch) => {
    if (ids) {
      dispatch(push(`/comparisonhighlight/${JSON.stringify(ids)}`));
    } else {
      dispatch(push('/comparisonhighlight'));
    }
  };
}

export function goComparisonSearchPage(ids?: number[]): PagesAction {
  return (dispatch) => {
    if (ids) {
      dispatch(push(`/comparisonsearch/${JSON.stringify(ids)}`));
    } else {
      dispatch(push('/comparisonsearch'));
    }
  };
}

export function goSearchPage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/search'));
  };
}

export function goUpalodRiskJudgePage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/riskjudge'));
  };
}

export function goJudgePage(): PagesAction {
  return (dispatch) => {
    dispatch(push('/judge'));
  };
}



// WEBPACK FOOTER //
// ./src/modules/pages.ts